import React from "react";
import i18n from "../lib/i18n";
import FacilityPartListContainer from "./FacilityPartListContainer";
import Modal from "./Modal";

const FacilityPartModal = (props) => {
  return (
    <Modal
      title={i18n.t("js.components.facility_part_modal.title")}
      onClose={props.onClose}
      includeDialog={false}
      closeLabel={i18n.t("js.components.facility_part_modal.close")}
    >
      <FacilityPartListContainer
        onSelect={props.onSelect}
        facility={props.facilityId}
        maintenancePlan={props.maintenancePlanId}
      />
    </Modal>
  );
};

export default FacilityPartModal;
